import React from 'react';
import PageHero from '../components/PageHero';
import OldQuarter from '../images/Hanoi - Old Quarter.jpg';
import './pages.css';
import './RSVP.css';

const RSVP = () => (
  <div className="page" style={{ backgroundImage: `linear-gradient(rgba(22,23,25,0.6), rgba(22,23,25,0.6)), url(${OldQuarter})`, backgroundSize: 'cover', backgroundPosition: 'center', backgroundAttachment: 'scroll' }}>
    <PageHero title="RSVP" image={OldQuarter} />
    <div className="page-inner">

      <div className="rsvp-message">
        <p className="rsvp-message-body">
          To keep our celebration intimate, RSVP details will be sent directly to invited guests.
        </p>
        <p className="rsvp-message-body">
          If you have received your invitation, please check your message for the RSVP link. If you have any questions, feel free to reach out to Mac or Kyla directly.
        </p>
        <p className="rsvp-message-note">
          Kindly confirm your attendance by <strong>April 10, 2026</strong>.
        </p>
      </div>

      <div className="rsvp-after-party">
        <p className="rsvp-after-party-label">After-Wedding Celebration</p>
        <p className="rsvp-after-party-date">April 26, 2026</p>
        <p className="rsvp-after-party-body">
          The celebration continues the day after at our home. We would love to have you join us for a more relaxed gathering as we begin our new chapter together.
        </p>
        <a
          href="https://maps.app.goo.gl/7z6tB5rPuYrAJgxy6"
          target="_blank"
          rel="noreferrer"
          className="rsvp-map-link"
        >
          View Location on Maps →
        </a>
      </div>
    </div>
  </div>
);

export default RSVP;
